import React, { useEffect, useState, memo } from "react";
import { fetchPublicationByIssueYearGroups, fetchPublicationByIssueList } from "../../../services/publicationSearchService";

const JournalCover = memo(({ mysqlId, defaultCover, auth }) => {
  const [coverUrl, setCoverUrl] = useState(defaultCover);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const getLatestCover = async () => {
      try {
        // 1) Önce derginin sahip olduğu yıl gruplarını çekiyoruz
        const yearsRes = await fetchPublicationByIssueYearGroups(mysqlId, "Dergi", 1);
        
        if (isMounted && yearsRes?.status === "OK" && yearsRes.data?.length > 0) {
          // Yılları sayısal olarak sıralayıp en büyüğünü (en güncelini) alıyoruz
          const latestYear = yearsRes.data
            .map(y => parseInt(y.key, 10))
            .sort((a, b) => b - a)[0];

          if (latestYear) {
            // 2) En güncel yıla ait sayı listesini çekiyoruz
            // newpagesize=1 vererek sadece en son eklenen sayıyı alıyoruz (Verimlilik!)
            const issuesRes = await fetchPublicationByIssueList(
                mysqlId, 
                "Dergi", 
                latestYear, 
                1, 
                1, // sayfa
                1  // newpagesize: Sadece 1 tane getir
            );

            if (isMounted && issuesRes?.status === "OK" && issuesRes.data?.length > 0) {
              const latestIssue = issuesRes.data[0];
              if (latestIssue.coverimage) {
                setCoverUrl(`https://idealonline.com.tr/service/idealonline/v1/publications/search/displayFile/${latestIssue.mysqlId}/${latestIssue.coverimage}`);
              }
            }
          }
        }
      } catch (err) {
        console.error("Kapak yükleme hatası:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    getLatestCover();
    return () => { isMounted = false; };
  }, [mysqlId, auth?.token]);

  return (
    <div className="cover-wrapper" style={{ 
        position: 'relative', 
        width: '100%', 
        height: '140px', 
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        overflow: 'hidden'
    }}>
      {loading && (
        <div className="d-flex align-items-center justify-content-center w-100 h-100">
          <div className="spinner-border spinner-border-sm text-secondary" role="status" />
        </div>
      )}
      <img
        src={coverUrl}
        alt="cover"
        className="img-fluid"
        style={{ 
            height: '100%', 
            width: '100%', 
            objectFit: 'contain',
            opacity: loading ? 0 : 1,
            transition: 'opacity 0.3s ease-in'
        }}
      />
    </div>
  );
});

JournalCover.displayName = "JournalCover";

export default JournalCover;